import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import fontService, { FontWeight, TextType } from 'services/FontService';
import { Colors } from 'context';

/**
 * Плашка режима предпросмотра (ТЗ 0039 доводка).
 *
 * 🔴 Обязательна на КАЖДОМ экране раздела. Методист смотрит центр глазами
 * студента, и без подписи он прочитает пустое резюме и ноль медалей как
 * поломку продукта, а не как «у смотрящего своих данных нет». Ровно та же
 * причина, по которой карта навыков подписывает трек по умолчанию.
 */
export const CareerPreviewNotice = memo(() => {
  const { t } = useTranslation();

  return (
    <Notice>
      <Title>{t('careerCenter.preview.title')}</Title>
      <Text>{t('careerCenter.preview.text')}</Text>
    </Notice>
  );
});

const Notice = styled.div`
  margin-bottom: 18px;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px dashed ${Colors.main};
  background: ${Colors.bg_gray};
`;

const Title = styled.p`
  margin: 0 0 4px;
  ${fontService.text({ type: TextType.small, weight: FontWeight.bold })}
`;

const Text = styled.p`
  margin: 0;
  color: ${Colors.gray_dark};
  ${fontService.text({ type: TextType.extraSmall })}
`;
